<template>
    <div class="check-accept-address">
        <div class="info">
            <div class="info-left">
                <div class="icon-accept"></div>
                <div class="info-text">
                    <p><span>{{ addressInfo.name }}</span><span class="phone">{{ addressInfo.concatPhone }}</span></p>
                    <p>{{addressInfo.provinceName + addressInfo.cityName + addressInfo.districtName +
                        (addressInfo.clothingCityName||'') + addressInfo.address}}</p>
                </div>
            </div>
            <div class="book-icon" @click="uncheck" v-if="showDel">
                <span class="icon-delete"></span>
            </div>
            <div class="book-icon" @click="addressBook" v-else>
                <span class="icon-book"></span>
            </div>
        </div>
        <ul class="goods-info">
            <li>
                <div @click="handlePayMeansClick">
                    <span class="icon icon-payment"></span>
                    <div>付款方式：{{addressInfo.payMeansName}}</div>
                </div>
                <van-icon name="arrow"/>
            </li>
            <li>
                <div @click="handleDeliveryClick">
                    <span class="icon icon-delivery"></span>
                    <div>配送方式：{{addressInfo.deliveryName}}</div>
                </div>
                <van-icon name="arrow"/>
            </li>

        </ul>
        <div style="display: flex;flex-direction: row">
            <div class="goods-info__number">
                <div>
                    <span class="icon icon-box"></span>
                    <div style="width: 70px;">货物件数：</div>
                </div>
                <input @input="handleGoodsNumberInput" :value="addressInfo.goodsNumber" placeholder="请输入"
                       class="goods-info__control" type="number">
                <span>件</span>
            </div>
            <div class="goods-info__number">
                <div>
                    <span class="icon icon-weight"></span>
                    <div style="width: 1.33rem;">重量：</div>
                </div>
                <input @input="handleWeightInput" :value="addressInfo.weight" placeholder="请输入"
                       class="goods-info__control" type="number">
                <span>kg</span>
            </div>
        </div>
        <ul class="goods-info">
            <li>
                <div @click="handleProductClick">
                    <span class="icon icon_productName"></span>
                    <div>品名：{{addressInfo.productName}}</div>
                </div>
                <van-icon name="arrow"/>
            </li>
            <li>
                <div @click="handlePackClick">
                    <span class="icon icon_packName"></span>
                    <div>包装：{{addressInfo.packName}}</div>
                </div>
                <van-icon name="arrow"/>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "CheckedAcceptAddress",
        props: {
            addressInfo: Object,
            showDel: Boolean
        },
        data() {
            return {
                params: {}
            }
        },
        mounted() {
            document.querySelectorAll('.goods-info__control').forEach(val => {
                val.addEventListener('blur', () => {
                    window.scrollTo(0, 0)
                })
            })
        },
        methods: {
            addressBook() {
                this.$router.push('/acceptAddressList')
            },
            uncheck() {
                let list = JSON.parse(JSON.stringify(this.$store.state.acceptList))
                let i = list.findIndex(val => val.id === this.addressInfo.id)
                list.splice(i, 1)
                this.$store.commit({
                    type: "confirmSelect",
                    t: 2,
                    list: list
                })
            },
            handlePayMeansClick() {
                this.$emit('on-pay-means-click')
            },
            handleDeliveryClick() {
                this.$emit('on-delivery-click')
            },
            handleProductClick() {
                this.$emit('on-product-click')
            },
            handlePackClick() {
                this.$emit('on-pack-click')
            },
            handleGoodsNumberInput({target}) {
                let list = JSON.parse(JSON.stringify(this.$store.state.acceptList))
                list.some(val => {
                    if (val.id === this.addressInfo.id) {
                        val.goodsNumber = target.value
                    }
                    return val.id === this.addressInfo.id
                })
                this.$store.commit({
                    type: "confirmSelect",
                    t: 2,
                    list: list
                })
            },
            handleWeightInput({target}) {
                let list = JSON.parse(JSON.stringify(this.$store.state.acceptList))
                list.some(val => {
                    if (val.id === this.addressInfo.id) {
                        val.weight = target.value
                    }
                    return val.id === this.addressInfo.id
                })
                this.$store.commit({
                    type: "confirmSelect",
                    t: 2,
                    list: list
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .check-accept-address {
        background-color: #fff;
        margin-top: 0.13rem;
    }

    .info {
        display: flex;
        flex-direction: row;
        padding: 10px 15px;
        align-items: center;
        line-height: 26px;
        font-size: 0.35rem;

        &-text {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }

        .info-left {
            display: flex;
            flex: 1;
            align-items: center;
        }
    }

    .goods-info {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        > li {
            flex-basis: 50%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0.25rem 0.4rem;
            font-size: 0.35rem;
            box-sizing: border-box;
            height: 0.85rem;

            > div {
                flex: 1;
                display: flex;
                flex-direction: row;
                align-items: center;
            }
        }

        .goods-info__control {
            background-color: #F5F5F5;
            width: 1.33rem;
            border: 0;
            outline: 0;
            padding: 0;
            text-align: center;
        }
    }

    .goods-info__number {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0.25rem 0.4rem;
        font-size: 0.35rem;
        box-sizing: border-box;
        height: 0.85rem;
        width: 50%;
        overflow: hidden;

        > div {
            display: flex;
            flex-direction: row;
            align-items: center;
        }

        .goods-info__control {
            background-color: #F5F5F5;
            width: 1.33rem;
            border: 0;
            outline: 0;
            padding: 0;
            text-align: center;
        }
    }

    .icon {
        display: inline-block;
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.25rem;
        background-size: 100%;
        background-repeat: no-repeat;

        &.icon-payment {
            background-image: url(../../../assets/icon_paymengt.png);
        }

        &.icon-delivery {
            background-image: url(../../../assets/icon_delivery.png);
        }

        &.icon-box {
            background-image: url(../../../assets/icon_box.png);
        }

        &.icon_productName {
            background-image: url(../../../assets/icon_type.png);
        }

        &.icon_packName {
            background-image: url(../../../assets/icon_pack.png);
        }

        &.icon-weight {
            background-image: url(../../../assets/icon_collection.png);
        }
    }

    .phone {
        color: #999;
        margin-left: 0.25rem;
        font-size: 0.32rem;
    }

    .icon-accept {
        margin-right: 0.25rem;
        width: 0.64rem;
        height: 0.9rem;
        display: block;
        box-sizing: border-box;
        padding: 4px 8px 12px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
        background-image: url(../../../assets/order1.png);
    }

    .icon-book {
        display: block;
        width: 0.5rem;
        height: 0.5rem;
        background-size: 100%;
        background-repeat: no-repeat;
        border-left: 1px solid #ddd;
        padding-left: 0.25rem;
        background-origin: content-box;
        margin-left: 0.25rem;
        background-image: url(../../../assets/contact.png);
    }

    .icon-delete {
        display: block;
        width: 0.5rem;
        height: 0.5rem;
        background-size: 100%;
        background-repeat: no-repeat;
        border-left: 1px solid #ddd;
        padding-left: 0.25rem;
        background-origin: content-box;
        margin-left: 0.25rem;
        background-image: url(../../../assets/icon_delete.png);
    }
</style>
